export default "__VITE_ASSET__$FV1$XOj__"